import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { i18n } from "@/utils/i18n";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "Layout",
    redirect: "/home",
    component: () => import("@/views/Layout/index"),
    children: [
      {
        path: "/home",
        name: "Home",
        meta: {
          title: i18n.t("官網首頁"),
        },
        component: () => import("@/views/Home/index"),
      },
      {
        path: "/serve",
        name: "Serve",
        meta: {
          title: i18n.t("客服中心"),
        },
        component: () => import("@/views/Serve/index"),
      },
      {
        path: "/serveDetail",
        name: "Serve",
        meta: {
          title: i18n.t("客服中心"),
        },
        component: () => import("@/views/Serve/detail"),
      },
      {
        path: "/message",
        name: "Message",
        meta: {
          title: i18n.t("最新消息"),
        },
        component: () => import("@/views/Message/index"),
      },
      {
        path: "/messageDetail",
        name: "Message",
        meta: {
          title: i18n.t("最新消息"),
        },
        component: () => import("@/views/Message/detail"),
      },
      {
        path: "/information",
        name: "Information",
        meta: {
          title: i18n.t("遊戲資訊"),
        },
        component: () => import("@/views/Information/index"),
      },
      {
        path: "/imformationDetail",
        name: "Information",
        meta: {
          title: i18n.t("遊戲資訊"),
        },
        component: () => import("@/views/Information/detail"),
      },
      {
        path: "/download",
        name: "Download",
        meta: {
          title: i18n.t("游戲下載"),
        },
        component: () => import("@/views/Download/index"),
      },
      {
        path: "/question",
        name: "Question",
        meta: {
          title: i18n.t("1:1詢問"),
        },
        component: () => import("@/views/Question/index"),
      },
      {
        path: "/questionEdit",
        name: "Question",
        meta: {
          title: i18n.t("1:1詢問"),
        },
        component: () => import("@/views/Question/edit"),
      },
      {
        path: "/questionDetail",
        name: "Question",
        meta: {
          title: i18n.t("1:1詢問"),
        },
        component: () => import("@/views/Question/detail"),
      },
      {
        path: "/community",
        name: "Community",
        meta: {
          title: i18n.t("社群"),
        },
        component: () => import("@/views/Community/index"),
      },
      {
        path: "/addcommunity",
        name: "Community",
        meta: {
          title: i18n.t("發文"),
        },
        component: () => import("@/views/Community/add"),
      },
      {
        path: "/communityDetail",
        name: "Community",
        meta: {
          title: i18n.t("社群"),
        },
        component: () => import("@/views/Community/detail"),
      },
      {
        path: "/mall",
        name: "Mall",
        meta: {
          title: i18n.t("商城"),
        },
        component: () => import("@/views/Mall/index"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: i18n.t("登入"),
    },
    component: () => import("@/views/Login/index"),
  },
  {
    path: "/reservation",
    name: "Reservation",
    meta: {
      title: i18n.t("预约"),
    },
    component: () => import("@/views/Reservation/index"),
  },
  {
    path: "/launcher",
    name: "Launcher",
    meta: {
      title: i18n.t("Launcher"),
    },
    component: () => import("@/views/Message/launcher"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});


function parseSearchParams(search){
  let searchParamsString = search.slice(1)
  return searchParamsString.split('&').reduce((searchParams, curKV)=>{
      const [k, v] = curKV.split('=').map(decodeURIComponent);
      searchParams[k] = v;
      return searchParams;
  }, {});
}


router.beforeEach((to, from, next) => {
  let search = window.location.search
  if (search) {
      window.history.replaceState({}, 'panggame', window.location.origin)
      let query = parseSearchParams(search)
      next({
          path: to.path,
          query: {
              ...to.query,
              ...query
          },
      })
  }
  else if (from.query.utm_source && !to.query.utm_source){
      let query = {}
      if (from.query.utm_source)
          query.utm_source = from.query.utm_source
      if (from.query.utm_campaign)
          query.utm_campaign = from.query.utm_campaign
      if (from.query.utm_medium)
          query.utm_medium = from.query.utm_medium
      next({
          path: to.path,
          query: {
              ...to.query,
              ...query
          },
      })
  }
  else {
    store.dispatch("setModule", { title: to.meta.title, path: to.path });
    if (to.path === "/home") {
      store.dispatch("setFixed", true);
      next();
      document.title = "Karos Online";
    } else {
      store.dispatch("setFixed", false);
      next();
    }
    document.documentElement.scrollTop = 0;
  }
});
export default router;
